import React from "react";

const FileResetIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_21246_74212)">
      <path
        d="M12 5V2L8 6L12 10V7C15.31 7 18 9.69 18 13C18 15.97 15.83 18.43 13 18.91V20.93C16.95 20.44 20 17.08 20 13C20 8.58 16.42 5 12 5Z"
        fill="#9E9E9E"
      />
      <path
        d="M6 12.9998C6 11.3498 6.67 9.84984 7.76 8.75984L6.34 7.33984C4.9 8.78984 4 10.7898 4 12.9998C4 17.0798 7.05 20.4398 11 20.9298V18.9098C8.17 18.4298 6 15.9698 6 12.9998Z"
        fill="#9E9E9E"
      />
    </g>
    <defs>
      <clipPath id="clip0_21246_74212">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
FileResetIcon.defaultProps = {
  className: "",
  color: "",
};

export default FileResetIcon;
